import * as React from 'react';
import mailStore from 'owa-mail-store/lib/store/Store';
import { observer } from 'mobx-react';

const styles = require('./FolderPaneTree.scss');
const classNames = require('classnames/bind');

export interface ReadUnreadOrTotalCountPillProps {
    folderId: string;
    isSelected: boolean;
    isTotalCount: boolean;
    treeNodeViewId: string;
}

/**
 * ReadUnread or Total count pill in the folder pane.
 * @param isSelected - Is current folder selected
 * @param isTotalCount - Should display total or unread count
 * @param folderId - folderId
 */
const ReadUnreadOrTotalCountPill = (props: ReadUnreadOrTotalCountPillProps): JSX.Element => {
    const { folderId, isSelected, isTotalCount, treeNodeViewId } = props;
    const folder = mailStore.folders.folderTable.get(folderId);
    const count = isTotalCount ? folder.TotalCount : folder.UnreadCount;

    return count !== 0 ? (
        <label
            htmlFor={treeNodeViewId}
            className={classNames(styles.readUnreadOrTotalCount, styles.unReadCountOrSelected, {
                [styles.totalCount]: !isSelected && isTotalCount,
            })}
            aria-hidden={'true'}>
            {count}
        </label>
    ) : null;
};

export default observer(ReadUnreadOrTotalCountPill);
